import { CssProps } from '@/theme/theme';
import { typography } from '@/theme/utils';
import { ComponentProps, ElementType } from 'react';

type TypographyProps<T extends ElementType = 'div'> = {
	as?: T;
	font?: keyof CssProps['font'];
	size?: keyof CssProps['font'][keyof CssProps['font']]['size'];
	weight?: keyof CssProps['font'][keyof CssProps['font']]['weight'];
	fontStyle?: 'italic' | 'normal';
	textDecoration?: 'underline' | 'none';
	transform?: 'none' | 'uppercase' | 'lowercase';
} & ComponentProps<T>;

export function Typography<T extends ElementType = 'div'>({
	as: Component = 'div',
	font = 'serif',
	size = 'm',
	weight = 'normal',
	fontStyle = 'normal',
	textDecoration = 'none',
	transform = 'none',
	...props
}: TypographyProps<T>) {
	return <Component css={typography({ font, weight, size, style: fontStyle, decoration: textDecoration, transform })} {...props} />;
}

export const H1 = (props: TypographyProps) => <Typography as="h1" weight="bold" size="xl" {...props} />;

export const H2 = (props: TypographyProps) => <Typography as="h2" weight="bold" size="l" {...props} />;

export const H3 = (props: TypographyProps) => <Typography as="h3" weight="bold" size="m" {...props} />;

export const H4 = (props: TypographyProps) => <Typography as="h3" weight="normal" size="m" fontStyle="italic" {...props} />;

export const H5 = (props: TypographyProps) => <Typography as="h3" weight="bold" size="s" {...props} />;

export const H6 = (props: TypographyProps) => <Typography as="h3" weight="normal" size="s" fontStyle="italic" {...props} />;

export const P = (props: TypographyProps) => <Typography as="p" {...props} />;
